export default "__VITE_ASSET__SH3JcDOvWNcn2WIvxBnLpg__ 480w, __VITE_ASSET__OestAvA2SyLT4CG6L76dAw__ 768w, __VITE_ASSET__TX5a1iViCylaCWPFSCQG2w__ 1200w";